// Tailwind doesn't support interpolation so this function
export const getTailwindLineClamp = (lineClamp = 0) => {
  const lineClampArray = [
    "line-clamp-1",
    "line-clamp-2",
    "line-clamp-3",
    "line-clamp-4",
    "line-clamp-5",
    "line-clamp-6",
  ];
  return lineClampArray[lineClamp - 1];
};
